<template>
    <el-row :gutter="20" class="main_block">
        <div class="mianContent">
            <div class="table">
                <div class="btns">
                    <span class="page-title">{{$route.meta.title}}</span>
                    <el-button class="add-btn" @click="onAdd" v-if="tableData.length>0">添加抬头</el-button>
                </div>
                <ExTable
                    :table-list="tableData"
                    :header="header"
                    :isIndex="false"
                    :isBorder="false"
                    height="300"
                    ref="multipleTable"
                    tableName="table"
                    :total="total"
                    :tableId="1"
                    :activeIndex="searchParam.page"
                    :pageSizeNum="pageSizeNum"
                    @clickPage="clickPage"
                    @clickSize="clickSize"
                >
                    <EmptyData slot="empty" message="暂无发票抬头"></EmptyData>
                    <el-table-column slot="titleType" label="发票抬头类型" align="left" min-width="70">
                        <template slot-scope="scope">
                            {{ scope.row.titleType === 0 ? '企业' : '个人/非企业单位' }}
                        </template>
                    </el-table-column>
                    <el-table-column slot="titleName" label="名称" align="left" min-width="200" :show-overflow-tooltip="false">
                        <template slot-scope="scope">
                            <div class="titleName">
                                <p class="cnt" :title="scope.row.titleName">{{ scope.row.titleName }}</p>
                                <b class="isDefult" v-if="scope.row.isDefault">默认</b>
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column slot="taxNo" label="税号" align="left" min-width="100">
                        <template slot-scope="scope">
                            {{ scope.row.taxNo || '-' }}
                        </template>
                    </el-table-column>
                    <el-table-column slot="switch" label="默认抬头" align="left" width="120">
                        <template slot-scope="scope">
                            <el-switch
                                v-model="scope.row.isDefault"
                                :active-value="1"
                                :inactive-value="0"
                                active-color="#3887FE"
                                @change="onDefaultChange(scope.row)"
                            >
                            </el-switch>
                        </template>
                    </el-table-column>
                    <el-table-column slot="operate" label="操作" align="left" width="150">
                        <template slot-scope="scope">
                            <div class="btn-group">
                                <p class="btn" @click="onEdit(scope.row)">编辑</p>
                                <p class="btn" @click="onDelete(scope.row)">删除</p>
                            </div>
                        </template>
                    </el-table-column>
                </ExTable>
                <div class="addTitle" v-if="tableData.length===0">
                    <el-button class="add-btn" @click="onAdd">添加抬头</el-button>
                </div>
            </div>
        </div>
        <!-- 添加/编辑抬头弹窗 -->
        <InvoiceDialog
            :visible.sync="formDialogVisible"
            :title="isEdit ? '编辑发票抬头' : '添加发票抬头'"
            width="600px"
            cancelText="取消"
            confirmText="保存"
            @confirm="onFormConfirm"
            @cancel="onFormCancel"
            @close="onFormCancel"
        >
            <div class="dialog-form-body">
                <InvoiceTitleForm ref="titleForm" :data="editData" />
            </div>
        </InvoiceDialog>
    </el-row>
</template>

<script>
import {getTitleList,setDefaultTitle,addTitle,cancelDefaultTitle,deleteTilte,editeTitle} from "@http/invoice/index";
import {filterParams} from "@/utils/filter";
import ExTable from "@com/ExTable";
import InvoiceDialog from "@/components/Invoice/dialog.vue";
import InvoiceTitleForm from "@/components/Invoice/titleForm.vue";
import TsaTooltip from "@/components/TsaTooltip.vue";
import EmptyData from "@/components/Invoice/emptyData.vue"
export default {
    data() {
        return {
            formDialogVisible: false,
            isEdit: false,
            editData: {},
            tooltipRow: null,
            tableData:[],
            searchParam: {
                page: 1,
                size: 10,
            },
            pageSizeNum:10,
            total: 10,
            header: [
                {
                    minWidth:100,
                    slot: 'titleType'
                },
                {
                    slot: "titleName",
                    minWidth:200,
                },
                {
                    minWidth:100,
                    slot: 'taxNo'
                },
                {
                    minWidth:100,
                    slot: 'switch'
                },
                {
                    minWidth:100,
                    slot: 'operate'
                }
            ],
        }
    },

    components: {ExTable, InvoiceDialog, InvoiceTitleForm, TsaTooltip,EmptyData},

    computed: {},

    created() {
        this.getTableData(filterParams(this.searchParam))
    },

    mounted() {},

    methods: {
        onTitleHover(event) {
            const el = event.target;
            el.title = el.scrollWidth > el.clientWidth ? el.textContent : '';
        },

        async getTableData(data) {
            let res = await getTitleList(data);
            console.log(res)
            this.tableData = res.data;
            this.total = res.total;
        },

        clickPage(page){
            this.searchParam.page=page;
            this.getTableData(filterParams(this.searchParam));
        },
        clickSize(size){
            this.searchParam.page=1;
            this.searchParam.size=size;
            this.pageSizeNum=size;
            this.getTableData(filterParams(this.searchParam));
        },
        onDefaultChange(row){
            const api = row.isDefault === 1 ? setDefaultTitle : cancelDefaultTitle;
            api({id:row.id}).then(()=>{
                this.getTableData(filterParams(this.searchParam))
            }).catch((err)=>{
                console.log(err)
            })
        },
        onAdd(){
            this.isEdit = false;
            this.editData = {};
            this.formDialogVisible = true;
        },
        onEdit(row){
            this.isEdit = true;
            this.editData = { ...row };
            this.formDialogVisible = true;
        },
        onFormConfirm(){
            this.$refs.titleForm.validate().then((formData) => {
                const api = this.isEdit ? editeTitle : addTitle;
                api(formData).then(()=>{
                    this.$msg(this.isEdit ? '编辑成功' : '添加成功', 'success');
                    this.formDialogVisible = false;
                    this.getTableData(filterParams(this.searchParam));
                }).catch((err)=>{
                    console.log(err)
                })
            }).catch(() => {});
        },
        onFormCancel(){
            this.formDialogVisible = false;
            this.$refs.titleForm.resetForm();
        },
        onDelete(row){
            this.$confirm('确认删除该发票抬头？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteTilte(row.id).then(() => {
                    this.$msg('删除成功', 'success');
                    this.getTableData(filterParams(this.searchParam));
                }).catch((err) => {
                    console.log(err);
                });
            }).catch(() => {});
        },
    },
}
</script>
<style lang='less' scoped>
.mianContent{
    height: 100%;
}
.dialog-form-body {
    padding: 24px 28px;
}
.table{
    margin-top:20px;
    .table-empty{
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 40px 0;
        img{
            width: 120px;
            height: 120px;
            margin-bottom: 16px;
        }
        p{
            margin: 0;
            font-size: 14px;
            color: #909399;
        }
    }
    .titleName{
        display: flex;
        align-items: center;
        .isDefult{
            margin-left: 7px;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 44px;
            height: 28px;
            background-color: rgba(0, 82, 255, 0.10);
            color: #0047FF;
            font-size: 12px;
            border-radius: 14px;
        }
    }
    .btn-group{
        display: flex;
        justify-content: flex-start;
        .btn{
            margin-right:24px;
            cursor: pointer;
            &:nth-child(1){
                color: #0052FF;
            }
            &:nth-child(2){
                color: #EF4444;
            }
        }
    }
    .addTitle{
        display: flex;
        justify-content: center;
        padding-top: 48px;
        .el-button{
            width: 180px;
            height: 50px;
            background: linear-gradient(153deg, #0052FF 0%, #4D7CFF 100%);
            border-radius: 14px;
            border: 1px solid transparent;
            color: #fff;
            font-size: 14px;
            font-weight: 500;
            cursor: pointer;
            transition: opacity 0.2s;
            &:hover {
                opacity: 0.9;
            }

            &:active {
                opacity: 0.8;
            }
        }
    }
}
.table ::v-deep .el-table__header th {
    background: #E2E8F0;
}
.btns {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
    .page-title{
        font-size: 14px;
        color: #333;
        font-weight: bold;
    }
    .add-btn {
        width: 110px;
        height: 50px;
        background: linear-gradient(153deg, #0052FF 0%, #4D7CFF 100%);
        border-radius: 14px;
        border: 1px solid transparent;
        color: #fff;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        transition: opacity 0.2s;

        &:hover {
            opacity: 0.9;
        }

        &:active {
            opacity: 0.8;
        }
    }
}
.titleName {
    display: flex;
    align-items: center;
    overflow: hidden;
    p {
        margin: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        min-width: 0;
    }
    b {
        flex-shrink: 0;
        margin-left: 6px;
    }
}
</style>